import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles/theme.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

const loadFonts = () => import('@fontsource-variable/plus-jakarta-sans');
if ('requestIdleCallback' in window) {
  requestIdleCallback(loadFonts, { timeout: 2500 });
} else {
  window.setTimeout(loadFonts, 1500);
}
